import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { makeHandle as e } from "../../core/handleUtils.js";
var t = Symbol("widget"),
    r = [],
    n = {},
    o = new WeakMap();

function i(e, t) {
  var o = t.children;
  if (o && o.length) for (var _r = 0; _r < o.length; ++_r) {
    o[_r] = i(e, o[_r]);
  } else o = r;
  var s = t.vnodeSelector;

  if (c(s)) {
    var _r2 = t.properties || n,
        _i = _r2.key || s;

    return {
      vnodeSelector: "div",
      properties: {
        key: _i,
        afterCreate: d,
        afterUpdate: a,
        afterRemoved: l,
        parentWidget: e,
        widgetConstructor: s,
        widgetProperties: _objectSpread(_objectSpread({}, _r2), {}, {
          key: _i,
          children: o
        })
      },
      children: void 0,
      text: void 0,
      domNode: null
    };
  }

  return t;
}

function d(t, r, n, _ref) {
  var i = _ref.parentWidget,
      d = _ref.widgetConstructor,
      a = _ref.widgetProperties;
  var c = new d(a);
  c.container = t, o.set(t, c), null == c.afterCreate || c.afterCreate(c, t), i._internalHandles.add(e(function () {
    return l(t);
  }));
}

function a(e, t, r, _ref2) {
  var n = _ref2.widgetProperties;
  var i = o.get(e);
  i && (i.set(n), null == i.afterUpdate || i.afterUpdate(i, e));
}

function l(e) {
  var t = o.get(e);
  t && (t.destroy(), o.delete(e));
}

function c(e) {
  return "function" == typeof e && e[t];
}

export { t as WIDGET_SYMBOL, c as isWidgetConstructor, i as processWidgets };